export default __webpack_public_path__ + "dc8d6e5216d3d0a751da0f3ff8a6366b.png";